import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useInsurancePolicyDetails } from "../../../CustomHooks/Queries";

import { formatCurrency, formatDate } from "../../../Utils/helpers";
import { longMonthDateFormat } from "../../../Utils/constants";

import { ArrowLeftCircle } from "../../../Assets/Icons";

import "./manage.scss";

export default function InsuranceManage() {
  const navigate = useNavigate();

  const { data: policyData, isLoading: isLoadingPolicy } = useInsurancePolicyDetails();

  const coverage = policyData?.coverage ?? {};

  if (isLoadingPolicy) {
    return (
      <div className="insurance-manage">
        <section className="card-section-wrapper">
          <div className="max-width-container">
            <div className="loading-content">
              <CircularProgress />
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="insurance-manage">
      <section className="card-section-wrapper">
        <div className="max-width-container">
          <div className="card-section">
            <div className="section-header">
              <button className="go-back-button" onClick={() => navigate(-1)} aria-label="Go back">
                <ArrowLeftCircle />
              </button>
              <h3 className="section-title">Renters Insurance</h3>
              <div className="dummy"></div>
            </div>
            <div className="content">
              <div className="top-container">
                <div className="section-header mb-4">
                  <h4 className="section-title">Policy Overview</h4>
                </div>
                <div className="policy-overview-card mb-5">
                  <div className="policy-number mb-1">{policyData?.policy_number || "N/A"}</div>
                  <div className="policy-effective-date">
                    Effective on {formatDate(policyData?.policy_effective_date ?? "", longMonthDateFormat) ?? ""}
                  </div>
                </div>
                <div className="section-header mb-4">
                  <h4 className="section-title">Policy Coverage</h4>
                </div>
                <div className="policy-coverage-card">
                  <div className="coverage-item">
                    <span className="coverage-label">Personal Liability</span>
                    <span className="coverage-value">
                      {coverage?.personal_liability ? formatCurrency(coverage?.personal_liability) : "N/A"}
                    </span>
                  </div>
                  <div className="coverage-item">
                    <span className="coverage-label">Personal Property</span>
                    <span className="coverage-value">
                      {coverage?.personal_property ? formatCurrency(coverage?.personal_property) : "N/A"}
                    </span>
                  </div>
                  <div className="coverage-item">
                    <span className="coverage-label">Deductible</span>
                    <span className="coverage-value">
                      {coverage?.deductible ? formatCurrency(coverage?.deductible) : "N/A"}
                    </span>
                  </div>
                  <div className="coverage-item">
                    <span className="coverage-label">Replacement Cost Coverage</span>
                    <span className="coverage-value">{coverage?.replacement_cost ? "Yes" : "No"}</span>
                  </div>
                  <div className="coverage-item">
                    <span className="coverage-label">Sewer/Drain Backup Coverage</span>
                    <span className="coverage-value">{coverage?.sewer_backup ? "Yes" : "No"}</span>
                  </div>
                  <div className="coverage-item">
                    <span className="coverage-label">Identity Fraud Expense Coverage</span>
                    <span className="coverage-value">{coverage?.identity_fraud_expense ? "Yes" : "No"}</span>
                  </div>
                  <div className="coverage-item">
                    <span className="coverage-label">Earthquake Coverage</span>
                    <span className="coverage-value">{coverage?.earthquake ? "Yes" : "No"}</span>
                  </div>
                </div>
              </div>
              <div className="bottom-container">
                <PrimaryButton onClick={() => window.open("https://support.sureapp.com/support/tickets/new", "_blank")}>
                  Need help? Contact Support
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
